import { render, staticRenderFns } from "./statementGroupsModal.vue?vue&type=template&id=00dbe476&"
import script from "./statementGroupsModal.vue?vue&type=script&lang=js&"
export * from "./statementGroupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports